import { SpeechAdapter } from './SpeechAdapter';

// ==============================|| WEB SPEECH API ADAPTER ||============================== //
//
// Uses the browser's built-in SpeechRecognition API (Chrome/Edge).
// Free, no API keys required. Supports Kannada (kn-IN), Hindi (hi-IN), etc.
//

class WebSpeechAdapter extends SpeechAdapter {
  constructor() {
    super();
    this._recognition = null;
  }

  isSupported() {
    return !!(window.SpeechRecognition || window.webkitSpeechRecognition);
  }

  start({ lang, continuous = true, interimResults = true, onResult, onError, onEnd, onStart }) {
    if (!this.isSupported()) {
      onError?.(new Error('Web Speech API is not supported in this browser'));
      return;
    }

    // Stop any existing session
    this.stop();

    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    this._recognition = new SpeechRecognition();
    this._recognition.lang = lang;
    this._recognition.continuous = continuous;
    this._recognition.interimResults = interimResults;

    this._recognition.onstart = () => {
      onStart?.();
    };

    this._recognition.onresult = (event) => {
      let interimTranscript = '';
      let finalTranscript = '';

      for (let i = event.resultIndex; i < event.results.length; i++) {
        const result = event.results[i];
        if (result.isFinal) {
          finalTranscript += result[0].transcript;
        } else {
          interimTranscript += result[0].transcript;
        }
      }

      if (finalTranscript) {
        onResult?.({ transcript: finalTranscript, isFinal: true });
      } else if (interimTranscript) {
        onResult?.({ transcript: interimTranscript, isFinal: false });
      }
    };

    this._recognition.onerror = (event) => {
      // 'no-speech' and 'aborted' are not real errors — ignore them
      if (event.error === 'no-speech' || event.error === 'aborted') return;
      onError?.(new Error(event.error));
    };

    this._recognition.onend = () => {
      onEnd?.();
    };

    this._recognition.start();
  }

  stop() {
    if (this._recognition) {
      this._recognition.stop();
      this._recognition = null;
    }
  }

  abort() {
    if (this._recognition) {
      this._recognition.abort();
      this._recognition = null;
    }
  }
}

export default WebSpeechAdapter;
